<template>
  <!-- <div class="container">
    <b-row>
      <b-col md="2">
        <p>Dossard</p>
        <p class="modal-res">{{ coureur.numero }}</p>
      </b-col>
      <b-col md="2">
        <p>Course</p>
        <p class="modal-res">{{ coureur.course }}</p>
      </b-col>
      <b-col md="2">
        <p>Catégorie</p>
        <p class="modal-res">{{ coureur.nom_categorie }}</p>
      </b-col>
      <b-col md="2">
        <p>Sexe</p>
        <p class="modal-res">
          <span v-if="coureur.sexe == 'F'">Femme</span
          ><span v-if="coureur.sexe == 'M'">Homme</span>
        </p>
      </b-col>
      <b-col md="2">
        <p>Club</p>
        <p class="modal-res">{{ coureur.club }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h3>Résultats</h3>
        <div class="line-heading"></div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="1">
        <p>Clt</p>
        <p class="modal-res">{{ coureur.classement }}</p>
      </b-col>
      <b-col md="2">
        <p>Temps</p>
        <p class="modal-res">{{ coureur.temps_arrondi }}</p>
      </b-col>
      <b-col md="2">
        <p>Vitesse</p>
        <p class="modal-res">{{ coureur.moyenne }}km/h</p>
      </b-col>
      <b-col md="2">
        <p>Allure</p>
        <p class="modal-res">{{ coureur.rythme }}min/km</p>
      </b-col>
      <b-col md="2">
        <p>Clt cat</p>
        <p class="modal-res">
          {{ coureur.classement_par_cat }}
          {{ coureur.abbrev_categorie }}
        </p>
      </b-col>
      <b-col md="2">
        <p>Clt sexe</p>
        <p class="modal-res">
          {{ coureur.classement_par_sexe }}
          {{ coureur.sexe }}
        </p>
      </b-col>
    </b-row>
    <b-row style="margin-top: 25px">
      <b-col>
        <b-button @click="downloadDiploma(coureur)"
          >Télécharger mon diplôme</b-button
        >
      </b-col>
    </b-row>
  </div> -->
  <div class="text-left">
    <div class="d-flex flex-row flex-wrap sm-gap align-items-center">
      <img class="fiche-flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" />
      <div class="bigger">{{ coureur.nom }} {{ coureur.prenom }}</div>
    </div>
    <div class="d-flex flex-row flex-wrap sm-gap">
      <div class="fiche-puce">Doss. <span class="fiche-values">{{ coureur.numero }}</span></div>
      <div class="fiche-puce">Cat. <span class=" fiche-values">{{ coureur.abbrev_categorie }}</span></div>
      <div class="fiche-puce">Sexe <span class=" fiche-values">{{ coureur.sexe }}</span></div>
    </div>
    <div class="text-left">
      <div>Club: <span class="font-weight-bold">{{ coureur.club != '' ? coureur.club : 'Pas de club' }}</span></div>
    </div>
    <hr />
    <div class="d-flex flex-row flex-wrap gap align-items-center">
      <img class="fiche-icon" src="../../assets/location_1042785.png" alt="">
      <div class="font-weight-bold bigger">{{ coureur.course }}</div>
    </div>
    <div class="mt-3">
      <div class="fiche-row">Temps <span class="bigger text-orange">{{
        coureur.temps_arrondi }}</span>
      </div>
      <div class="fiche-row">Classement <span class="bigger">{{
        coureur.classement }}°</span></div>
      <div class="fiche-row">Classement catégorie <span><span class="bigger">{{
        coureur.classement_par_cat }}</span> /{{
              coureur.nb_coureur_in_cat }} {{
            coureur.abbrev_categorie }}{{ coureur.sexe }}</span>
      </div>

      <div class="fiche-row">Classement sexe <span><span class="bigger">{{
        coureur.classement_par_sexe }}</span> /{{
              coureur.nb_coureur_in_sexe }} {{
            coureur.sexe }}</span>
      </div>
      <div class="fiche-row">Moyenne <span><span class="bigger">{{
        coureur.moyenne }}</span> km/h</span></div>
      <div class="fiche-row">Rythme <span><span class="bigger">{{
        coureur.rythme
            }}</span> min/km</span></div>
    </div>
    <b-row style="margin-top: 25px" v-if="diplome != 0">
      <b-col class="d-flex align-items-center">
        <b-button @click="downloadDiploma(coureur)">Télécharger mon diplôme</b-button>
      </b-col>
    </b-row>



  </div>
</template>

<script>
export default {
  components: {},
  props: ["coureur", "diplome", "nom_epreuve"],
  data() {
    return {};
  },
  computed: {

  },
  methods: {
    downloadDiploma() {
      if (this.diplome != 0) {
        let routeData = this.$router.resolve({
          name: "GetDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.coureur.id,
            nbc: this.coureur.nb_coureur_in_cat,
            nbs: this.coureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "GetGDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.coureur.id,
            nbc: this.coureur.nb_coureur_in_cat,
            nbs: this.coureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.fiche-values {
  font-weight: bold;
  font-size: 1.1rem;
}

.bigger {
  font-size: 1.2rem;
  font-weight: bold;
}

.fiche-puce {
  margin: 5px 0;
  padding: 0px 10px;
  background-color: #f0f0f1;
  border: 1px solid #e8e9eb;
  border-radius: 5px;
}

.fiche-icon {
  width: 25px;
  height: auto;
}

.fiche-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border: 1px solid #e8e9eb;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #f0f0f1;
}

.fiche-flag {
  height: 18px;
  width: auto;
  border-radius: 3px;

}

.sm-gap {
  gap: 8px;
}

.gap {
  gap: 15px;
}

.text-orange {
  color: #c47704;
}
</style>